<div class="container-fluid py-3">

    <form [formGroup]="tnaForm" autocomplete="off">
        <div class="row">
            <div class="col-md-3 my-1" *ngIf="!hideCompany">
                <label class="form-label required" for="company_id">{{'Company'|translate}}</label>
                <ng-select [items]="companyList" bindLabel="company_name" bindValue="id" class="emp_create"
                    [clearable]="false" formControlName="company_id" (change)="onCompanyChange($event)"
                    [ngClass]="{ 'is-invalid': isInvalid('company_id') }" placeholder="Select Company"
                    clearable="false">
                </ng-select>
                <app-validation-error [control]="tnaForm.get('company_id')" fieldName="Company Name" [submit]="submit">
                </app-validation-error>
                <!-- <div *ngIf="isInvalid('company_id')" class="invalid-feedback">
                    <span *ngIf="tnaForm.get('company_id')?.errors?.['required']">Company
                        is required.</span>
                </div> -->
            </div>
            <!-- Start date -->
            <div class="col-sm-3 my-1">
                <label class="form-label required">{{'Start Date'|translate}}</label>
                <p-calendar formControlName="start_date" [iconDisplay]="'input'" touchUI="true" [showIcon]="true"
                    styleClass="custom-calendar" inputId="icondisplay" [dateFormat]="date" [minDate]="minDate"
                    [maxDate]="maxDate" (onSelect)="onStartDateChange($event)"
                    [ngClass]="{ 'is-invalid': isInvalid('start_date') }">
                </p-calendar>
                <app-validation-error [control]="tnaForm.get('start_date')" fieldName="Start Date" [submit]="submit">
                </app-validation-error>
                <!-- <div *ngIf="isInvalid('start_date')" class="invalid-feedback">
                    <span *ngIf="tnaForm.get('start_date')?.errors?.['required']">Start Date is required.</span>
                </div> -->
            </div>
            <!-- End Date -->
            <div class="col-sm-3 my-1">
                <label class="form-label required">{{'End Date'|translate}}</label>
                <p-calendar formControlName="end_date" [iconDisplay]="'input'" touchUI="true" [showIcon]="true"
                    styleClass="custom-calendar" inputId="icondisplay" [dateFormat]="date" [minDate]="startDate"
                    [defaultDate]="startDate" [maxDate]="maxDate" (onSelect)="onDueDateChange($event)"
                    [ngClass]="{ 'is-invalid': isInvalid('end_date') }">
                </p-calendar>
                <app-validation-error [control]="tnaForm.get('end_date')" fieldName="End Date" [submit]="submit">
                </app-validation-error>
                <!-- <div *ngIf="isInvalid('end_date')" class="invalid-feedback">
                    <span *ngIf="tnaForm.get('end_date')?.errors?.['required']">End Date is required.</span>
                </div> -->
            </div>

            <!-- Employee Name -->
            <div class="col-md-3 my-1">
                <label class="form-label">{{'employee name'|translate}}/{{'code'|translate}}</label>
                <ng-select [items]="employeeList" (change)="onEmployeeChange($event)" bindLabel="fullName"
                    bindValue="id" class="emp_create" formControlName="employee_id" placeholder="Select Employee"
                    (clear)="onClearEmployee()">
                </ng-select>
            </div>
            <!-- Type -->
            <div class="col-md-3 my-1">
                <label class="form-label">{{'Type'|translate}}</label>
                <ng-select [items]="typeOption" bindLabel="label" bindValue="value" class="emp_create"
                    formControlName="type" [ngClass]="{ 'is-invalid': isInvalid('type') }"
                    (change)="onTypeChange($event)" (clear)="onClearEmployee()" placeholder="Select Type">
                </ng-select>
            </div>
        </div>
        <div class="mt-3 text-end">
            <button [disabled]="tnaForm.invalid || !hasSelected" type="button" class="btn submit btn-sm"
                (click)="formPresentOrAbsent('Present')">
                {{'Present'|translate}}
            </button>

            <button [disabled]="tnaForm.invalid || !hasSelected" type="button" class="btn submit btn-sm"
                (click)="formPresentOrAbsent('Absent')">
                {{'Absent'|translate}}
            </button>

            <button type="button" [disabled]="!hasSelected" class="btn submit btn-sm"
                (click)="postToMainAttendanceDb('Post')">
                {{'Post'|translate}}
            </button>

            <button type="button" class="btn submit btn-sm" [disabled]="empAttendanceList?.length == 0"
                (click)="postToMainAttendanceDb('Post All')">
                {{'Post All'|translate}}
            </button>

            <!-- <app-table-export-import-button *ngIf="empAttendanceList?.length && checkPermission('export')"
                [tableId]="'menusTable'" tablename="tna" [listData]="empAttendanceList" [reportName]="'tnaListTable'">
            </app-table-export-import-button> -->

            <!-- Export -->
            <!-- <div class="col-md-2 m-2 align-content-end"> -->
            <i class="fa-solid fa-download text-success" *ngIf="empAttendanceList?.length" title="Download Excel"
                (click)="downloadExcel()">
            </i>
            <!-- </div> -->

            <!-- <button type="button" class="btn submit btn-sm" (click)="pullRawData()">
                Pull Raw Data
            </button> -->
        </div>
    </form>

    <!-- Table Data List -->
    <div class="mt-3" *ngIf="showTable">
        <div class="mb-2 d-flex justify-content-end">
            <div class="input-group" style="max-width: 320px;">
                <span class="input-group-text"><i class="pi pi-search"></i></span>
                <input type="text" class="form-control" placeholder="Search employee name / code..."
                    [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()"
                    [ngModelOptions]="{standalone: true}">
                <button *ngIf="searchQuery" class="btn btn-outline-secondary" type="button"
                    (click)="searchQuery=''; onSearchChange()">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>
        <app-custom-table
            [listData]="empAttendanceList"
            [selectedColumns]="myColumns"
            [menuId]="menuId"
            [moduleKey]="'tnaListModule'"
            [tableName]="'tnaListTable'"
            [totalRecords]="totalRecords"
            [page]="page"
            [pageSize]="pageSize"
            [sectionid]="0"
            [angularDateFormat]="angularDateFormat"
            [dateFormat]="dateFormat"
            [showCheckbox]="true"
            [allChecked]="allSelected"
            [someChecked]="someChecked"
            [isRowChecked]="isRowCheckedFn"
            (rowCheckChange)="onRowCheckChange($event)"
            (checkAllChange)="onCheckAllChange($event)"
            (pageChanges)="handleFilterChange($event)"
            (edit)="openEditModal($event)"
            (deleteDraft)="deleteClick($event)">
        </app-custom-table>
        <ngb-pagination *ngIf="empAttendanceList?.length != 0" class="pagination-master" [maxSize]="pageSize"
            [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
            [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
        </ngb-pagination>
    </div>
</div>

<!-- Edit TNA times Modal -->
<ng-template #tnaEditModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{'Edit Attendance Times'|translate}}</h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="editTnaForm">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-3">
                        <label class="form-label required">{{'Check-In Time'|translate}}</label>
                        <div class="input-group">
                            <input class="form-control" formControlName="checkin_time" [ngxTimepicker]="tnaStartPicker"
                                placeholder="Select time" readonly>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" (click)="tnaStartPicker.open()">
                                    <i class="fa-regular fa-clock"></i>
                                </button>
                            </div>
                            <ngx-material-timepicker #tnaStartPicker [format]="24"></ngx-material-timepicker>
                            <app-validation-error [control]="editTnaForm.get('checkin_time')" fieldName="Check-In Time"
                                [submit]="submit">
                            </app-validation-error>
                            <!-- <div class="invalid-feedback"
                                *ngIf="editTnaForm.get('checkin_time')?.invalid && (editTnaForm.get('checkin_time')?.touched || editTnaForm.get('checkin_time')?.dirty)">
                                <span *ngIf="editTnaForm.get('checkin_time')?.errors?.['required']">Check-In time is
                                    required.</span>
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group mb-3">
                        <label class="form-label required">{{'Check-Out Time'|translate}}</label>
                        <div class="input-group">
                            <input class="form-control" formControlName="checkout_time" [ngxTimepicker]="tnaEndPicker"
                                placeholder="Select time" readonly>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" (click)="tnaEndPicker.open()">
                                    <i class="fa-regular fa-clock"></i>
                                </button>
                            </div>
                            <ngx-material-timepicker #tnaEndPicker [format]="24"></ngx-material-timepicker>
                            <app-validation-error [control]="editTnaForm.get('checkout_time')"
                                fieldName="Check-Out Time" [submit]="submit">
                            </app-validation-error>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group mb-3">
                        <label class="form-label required">{{'Remarks'|translate}}</label>
                        <textarea class="form-control" maxlength="300" formControlName="remarks" rows="2" placeholder="Enter remarks..."></textarea>
                        <app-validation-error [control]="editTnaForm.get('remarks')" fieldName="Remarks" [submit]="submit">
                        </app-validation-error>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm cancel" (click)="modal.dismiss()">{{'Cancel'|translate}}</button>
        <button type="button" class="btn btn-sm submit" [disabled]="editTnaForm.invalid || !formisDisable"
            (click)="saveEditTna()">{{'Update'|translate}}</button>
    </div>
</ng-template>